<template>
  <generic-modal
    size
    :title="$t('student account module configuration')"
    icon="settings"
    image="/images/icons/accounts.png"
    v-bind:scrolling="false"
    v-on:destroy="destroy"
    v-bind:on_finished="finished"
    @destroy="destroy"
  >
    <div class="description">
      <div class="ui top attached tabular menu" ref="tabs">
        <a class="active item" data-tab="types">{{ $t("movement types") }}</a>
        <a class="item" data-tab="settings">{{ $t("settings") }}</a>
      </div>
      <div class="ui bottom attached tab segment" data-tab="settings">
        <settings @close="destroy" :setup_in="stp" ref="settings" />
      </div>
      <div class="ui bottom attached active tab segment" data-tab="types">
        <movement-types style="margin-top:20px" />
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api, stringify } from "@/utils";
import GenericModal from "@/components/GenericModal";
import MovementTypes from "./MovementTypes";
import Settings from "./Settings";

export default {
  name: "StudentAccountConfigurationModal",
  components: {
    "generic-modal": GenericModal,
    MovementTypes,
    Settings,
  },
  computed: {},
  data() {
    return {
      setup: {},
      stp: {
        register_account: true,
        account_type: "",
        student_movement_policy: "",
      },
    };
  },
  methods: {
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        let _stp = vm.$refs.settings.getData();
        local_api(vm, "post", "/student_account/do-save-configuration", {
          s: _stp,
        })
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  mounted() {
    let vm = this;
    local_api(vm, "post", "/student_account/do-get-configuration")
      .then((conf) => {
        if (conf) {
          vm.stp = JSON.parse(conf.setup);
          setTimeout(() => {
            window
              .jQuery(vm.$refs.account_type_dropdown)
              .dropdown("set selected", vm.stp.account_type);
          }, 500);
        }
      })
      .catch((err) => {
        vm.$alertify.error(stringify(err));
      });

    setTimeout(() => {
      window
        .jQuery(this.$refs.tabs)
        .find(".item")
        .tab();
    }, 1000);
  },
  watch: {},
  updated: function() {},
};
</script>
